import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import {User} from '../../../domain/user';
import {filter} from 'rxjs/operators';
import {PopupService} from '../../../component/popup.service';
import {CoreConfigurationService} from '../../../core-configuration.service';

import shortUuid from 'short-uuid';
import {PageEvent} from '@angular/material/paginator';
import {UserEditComponent} from '../user-edit/user-edit.component';
import {Session} from '../../../domain/session';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
  standalone: false
})
export class UserListComponent implements OnInit {
  totalUserCount: number;
  users: User[];
  currentPage = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private navigateService: PopupService,
    public coreConfiguration: CoreConfigurationService,
    public session: Session) {
  }

  ngOnInit() {
    this.initValue();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.initValue();
      });

    this.route.queryParams.subscribe((params: Params) => {
      if (params['page'] != null) {
        this.currentPage = +params['page'] - 1;
      } else {
        this.currentPage = 0;
      }
    });
  }

  private initValue() {
    this.totalUserCount = this.route.snapshot.data['data'].TotalUserCount;
    this.users = this.route.snapshot.data['data'].Users;
  }

  changePage(event: PageEvent) {
    this.router.navigate(['/admin/users'], {queryParams: {page: event.pageIndex + 1}});
  }

  newUser() {
    this.editUser(new User());
  }

  editUser(user: User) {
    this.navigateService.openFromComponent(UserEditComponent, {user: user})
      .subscribe(() => {
        this.router.navigate(['/admin/users'], {queryParams: {page: this.currentPage + 1}});
      });
  }
}
